import classes from "./OurStrategy.module.scss";

function OurStrategy() {
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        Our <br /> <span>Strategy</span>
      </div>

      <div className={classes["strategy"]}>
        <img
          src="https://se-website-image.s3.ap-south-1.amazonaws.com/landing-page/our-strategy.svg"
          alt="Strategy"
          className={classes["strategy-img"]}
        />

        {/* <div className={classes["bottom-box"]}>
          {content.map((item, index) => (
            <React.Fragment key={index}>
              <div key={index} className={classes["item"]}>
                <div className={classes["icon"]}>{item.icon}</div>

                <p className={classes["text"]}>
                  <span>{item.title} : </span>
                  {item.desc}
                </p>
              </div>

              {index !== content.length - 1 && (
                <div className={classes.divider} />
              )}
            </React.Fragment>
          ))}
        </div> */}
      </div>
    </div>
  );
}

export default OurStrategy;
